
import React from "react";
import ListItem from "./ListItem";
import "./style.scss";

const ListContainer  = (props) => {

    let list = [
        {name: 'History', url: '/user/history'},
        {name: 'Bookmarked Classes', url: '/user/favorite'},
        {name: 'Concepts You Follow', url: '/following'}
    ]
    return <div className="neoListContainer">
            {list.map((item) => {
                return <ListItem key={item.name} name={item.name} url={item.url} />
            })}
    </div>
}

export default ListContainer;